import { getDuplicateDomainNameIndices } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";
import type { IRawCompetitor } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import type { IWebsiteItem } from "pro-features/components/AutocompleteWebsites/types";

export const COMPETITOR_DOMAIN_ERROR_KEYS = {
    duplicate: "llmTracker.campaignQuery.editBrand.error.duplicate",
    matchesTrackedDomain: "llm.setup.error.identical-domain-and-competitor",
} as const;

type CompetitorDomainErrorKey = (typeof COMPETITOR_DOMAIN_ERROR_KEYS)[keyof typeof COMPETITOR_DOMAIN_ERROR_KEYS];

export const getCompetitorDomainErrorKeys = (
    competitors: IRawCompetitor[],
    trackedDomains: IWebsiteItem[],
): Map<number, CompetitorDomainErrorKey> => {
    const domainNames = competitors.map(({ domain }) => domain?.name ?? "");
    const errorsByIndex = new Map<number, CompetitorDomainErrorKey>();
    const trackedDomainNames = new Set(
        trackedDomains.map(({ name }) => name?.trim().toLowerCase() ?? "").filter(Boolean) ?? [],
    );

    getDuplicateDomainNameIndices(domainNames).forEach((index) => {
        errorsByIndex.set(index, COMPETITOR_DOMAIN_ERROR_KEYS.duplicate);
    });

    domainNames.forEach((name, index) => {
        const domainName = name.trim().toLowerCase();

        if (domainName && trackedDomainNames.has(domainName)) {
            errorsByIndex.set(index, COMPETITOR_DOMAIN_ERROR_KEYS.matchesTrackedDomain);
        }
    });

    return errorsByIndex;
};
